import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlassChart } from '@fortawesome/free-solid-svg-icons';

import { internalControlsEnabled } from '../utils/permissions';
import type { BootstrapResponse } from '../api/bootstrap';

type Props = {
  bootstrap: BootstrapResponse | null;
  isCollapsedDesktop: boolean;
  onNavigate: () => void;
};

/**
 * Sidebar nav link for operator classification audit (internal build + role only).
 */
export function maybeRenderOperatorClassificationAuditNav({
  bootstrap,
  isCollapsedDesktop,
  onNavigate,
}: Props): React.ReactNode {
  if (!internalControlsEnabled(bootstrap?.user?.role)) {
    return null;
  }

  return (
    <div data-testid="NAV_OPERATOR_CLASSIFICATION_AUDIT">
    <NavLink
      to="/app/operator/classification-audit"
      aria-label="Classification audit"
      title={isCollapsedDesktop ? 'Classification audit' : undefined}
      onClick={onNavigate}
      className={({ isActive }) =>
        [
          'flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors',
          isActive ? 'bg-accent-muted text-theme font-medium' : 'text-theme hover:bg-theme-tertiary',
          isCollapsedDesktop ? 'justify-center px-2' : '',
        ].join(' ')
      }
    >
      <FontAwesomeIcon icon={faMagnifyingGlassChart} className="h-4 w-4 shrink-0" />
      {!isCollapsedDesktop ? <span>Classif. audit</span> : null}
    </NavLink>
    </div>
  );
}
